const axios = require('axios');
axios.defaults.baseURL = process.env.VUE_APP_URL;

function errorResponseHandler(error) {

    if (error && error.response && error.response.status == '401' && error.response.data === 'Please login first.') {
        if (window.location && window.location.href && window.location.href.indexOf('/tournaments') >= 0) {
            setTimeout(function(){
                window.location.reload();
            }, 10);
        }
    }
}

axios.interceptors.response.use(
    response => response,
    errorResponseHandler
);

export default axios;
